/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    // var container = event.target;
    if (variant) {
      // // console.log('Container ———————— ↓');
      // // console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // // ... update some element on the page

      let inventoryHash = document.querySelectorAll('[inventorymanagment]'); 
      Array.from(inventoryHash).forEach( 
        (Selectedvariant)=>{ 
          if(Selectedvariant.dataset.id == variant.id){ 
            if(Selectedvariant.dataset.inventory > 0){ 
              let quantity_threshold = parseInt(Selectedvariant.dataset.threshold);
              if(quantity_threshold && parseInt(Selectedvariant.dataset.inventory) <= quantity_threshold ){
                 $(".stock").show();
              }
              else if (quantity_threshold){
                $(".stock").hide();
              }
              $(".stock").html("<strong>"+Selectedvariant.dataset.inventory+"</strong> in stock only!"); 
                  document.querySelector('[name="properties[Availability]"]').setAttribute('disabled','');
            } 
            else{ 
              $(".stock").show();
              $(".stock").html("<strong>Out of stock!</strong>");
              
                if(Selectedvariant.dataset.available == 'true'){
                  document.querySelector('[name="properties[Availability]"]').removeAttribute('disabled');
                }else{
                  document.querySelector('[name="properties[Availability]"]').setAttribute('disabled','');
                }
            }
            
          } 
        } 
      ); 
     document.querySelectorAll('#devSliderPrice div').forEach(el => {
    if (el.dataset.id == variant.id + '') {
        let price = el.dataset.price;
       console.log(price);
        let devbtn = document.getElementById('devSpanPrice');
        let devPrimPrice =document.querySelector('.price-container .devPriceProd')
         console.log(devbtn);
        devbtn.innerText = price;
        devPrimPrice.innerText = price;
        }
    });

    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      // console.log('Cart ———————————— ↓');
      // console.log(cart);

      var countMessage = cart.item_count + " item";
      if (cart.item_count != 1) {
        countMessage = countMessage + "s";
      }
      $(".cart__template .header__cart__status span").html(countMessage)
    }
  });
  // Fired when page loads to update header values
  // document.addEventListener('theme:cart:init', (e) => {
  //   console.log('theme:cart:init');
  //   console.log(e);
  // });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // Change Banner # Links
  var current = window.location.pathname;

  if (current == '/') {
    // console.log('Is the homepage.')
    $(".navlink, #shopify-section-custom-footer .nav").each(function(){
      var myHref = $(this).attr("href");
      if (myHref.includes("#") ) {
        $(this).attr("href", myHref.replace("/pages/our-story#how-it-works", "#how-it-works"));
      }
    })
  } else {
    // console.log('Not on the homepage.')
  }

  // Open external links in new window
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
